import React from "react";
import { useLang } from "@/contexts/LanguageContext";

export default function Footer() {
  const { tr } = useLang();
  return (
    <footer className="mt-24 border-t border-white/5 bg-[#0a0a0c]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-[13px] text-[#a9a9b8] font-mono tracking-wider">
          PERSONA <span className="text-[#e6c687]">FRAGRANCE INTELLIGENCE</span>
        </div>
        <div className="pfi-overline" data-testid="heritage-badge">
          {tr("heritage_badge")}
        </div>
        <div className="text-xs text-[#6c6c7a]">© 2026 PERSONA</div>
      </div>
    </footer>
  );
}
